import request from '@/utils/request'

export function getMiniPath(data) {
    return request({
        url: 'wxshortlink/admin/link/getShortLink',
        method: 'post',
        data
    })
}
